import React from "react";
import history from "../utils/history";

import { primaryColor } from "assets/jss/xrs.js";
import ReactGA from "react-ga";
import * as URLS from "../utils/XRSAPIs";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { apiVersion } from "assets/jss/xrs";
const VersionDialog = () => {
  const [trackingCode, settrackingCode] = React.useState(null);
  const [trackingCodeInit, settrackingCodeInit] = React.useState(false);
  const [open, setopen] = React.useState(false);

  React.useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-bg",
      primaryColor[14]
    );

    fetch(URLS.GetSiteDetatilsAPIUrl, {
      method: "GET",
    })
      .then((res) => {
        if (res.status == 204) {
          setopen(true);
          throw Error("");
        } else if (res.status == 200 || res.status == 201) {
          return res.json();
        } else {
          throw Error("");
        }
      })
      .then((response) => {
        settrackingCode(response.trackingcode);
      })
      .catch((e) => {});
  }, []);

  React.useEffect(() => {
    if (trackingCode) {
      ReactGA.initialize(trackingCode);
      settrackingCodeInit(true);
    }
  }, [trackingCode]);

  React.useEffect(() => {
    if (trackingCodeInit) {
      const unlisten = history.listen((location) => {
        ReactGA.pageview(location.pathname);
      });
      return () => {
        unlisten();
      };
    }
  }, [history]);
  return (
    <Dialog open={open}>
      <DialogTitle id="simple-dialog-title">
        Error: Unsupported Version Detected.
      </DialogTitle>
      <DialogContent>
        The current version {apiVersion} is not supported.
      </DialogContent>
    </Dialog>
  );
};

export default VersionDialog;
